import { render, staticRenderFns } from "./GroupInformation.vue?vue&type=template&id=5e753214&scoped=true"
import script from "./GroupInformation.vue?vue&type=script&lang=js"
export * from "./GroupInformation.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/group_information.css?vue&type=style&index=0&id=5e753214&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e753214",
  null
  
)

export default component.exports